module.exports = __webpack_public_path__ + "img/logo.754f47af.svg";